import { inject, observer } from "mobx-react";
import React from "react";
import Script from "react-load-script";
import { logger } from "@fidget/common/utils";
import { config } from "@fidget/common/config/config";
import { ICurrentUserStore } from "../models/currentUser/CurrentUserStore";
import { IWidgetStore } from "../models/widget/WidgetStore";

interface Props {
  widgetStore?: IWidgetStore;
  currentUserStore?: ICurrentUserStore;
}

export const CloserWidget: React.SFC<Props> = inject(
  "widgetStore",
  "currentUserStore"
)(
  observer((props: Props) => {
    const { widgetStore, currentUserStore } = props;
    const { widgetUrl } = config.services;
    const { profile } = currentUserStore!;
    const { orgId } = profile!;

    return (
      <Script
        attributes={{ id: "closer-widget-script" }}
        url={widgetUrl}
        onCreate={() => {
          widgetStore!.setup(widgetUrl);
        }}
        onError={() => {
          logger.error("Could not load widget app");
          throw new Error("An error occurred while loading closer widget");
        }}
        onLoad={() => {
          widgetStore!.init(orgId);
        }}
      />
    );
  })
);
